/**
 * Component to show the listing information for all the tests passed
 */

import * as React from 'react';
import { Table, Modal, Card, Row, Col, Radio, Select  } from 'antd';
import { IcommonProps } from '../common/props';
import Utils from '../common/utils';
import '../../css/TestList.scss';
import { STATICKEYS, staticProperties } from '../common/staticProperties';
import { Link } from 'react-router-dom';
// import PdfCreation from '../common/pdfCreation';
import TestPdf from './testPdf';
import CanvasTestView from '../common/canvasTestView';
import service from '../../service/apolloclient.service';
import Auth from '../common/auth';
import { Tasks } from '../common/auth';
import { BASELINETYPE } from '../common/constants';
import strings from '../../eyeguide-localization/test/string.test';
import Token from '../common/token';
import { CustomSorter } from '../Sorter';
import LocalStorage from '../../service/localstorage';
import * as jsPDF from 'jspdf';

var doc = new jsPDF({
    orientation: 'landscape',
    unit: 'pt',
    format: 'letter',
});
var canvas: any = [];

const storage = new LocalStorage();
const RadioGroup = Radio.Group;
/**
 * Property definition 
 */
interface ITestListProps extends IcommonProps {
    tests: Array<any>;
    notifySelectedTests: any;
    notifyTestUpdated: any;
    pagination: boolean;
    sorting: boolean;
    showAthelete: boolean;
    showDownloadAction: boolean;
    showEditAction: boolean;
    loading: boolean;
    emptyText: string;
    testData?: any;
    notifyTestDownload?: any;
    fromProfileList?: boolean;
    testtags?: string; 
}

/**
 * State definition
 */
interface ITestListState {
    columnData: Array<any>;
    columns: Array<any>;
    pagination: any;
    loading: boolean;
    selectedRowKeys: Array<string>;
    emptyText: string;
    isModalVisisble: boolean;
    baseline: number;
    concussed: number;
    testToEdit: any;
    showHealthData: any;
    testtag: string;
}

export default class TestList extends React.Component<ITestListProps, ITestListState> {
    
    constructor(props: ITestListProps) {
        super(props);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        console.log('constructor', Token.decodeToken().roleid);
        this.state = {
            columnData: [],
            columns: [],
            pagination: {},
            loading: true,
            selectedRowKeys: [],
            emptyText: '',
            isModalVisisble: false,
            baseline: 0,
            concussed: 0,
            testToEdit: [],
            testtag: '',
            showHealthData: Token.decodeToken().roleid === '' ||
                            Token.decodeToken().roleid === undefined ? 
                            true : Auth.canPerformTask(roleid, Tasks.canViewHealthData)
        };
    }

    onSelectChange = (selectedRowKeys: Array<string>) => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({ selectedRowKeys });
        this.props.notifySelectedTests(selectedRowKeys);
      }

    componentDidMount() {
        console.log(navigator.language);
        strings.setLanguage(navigator.language);
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({ loading: true });
        if (staticProperties.get(STATICKEYS.clearSelection) === true) {
            staticProperties.set(STATICKEYS.clearSelection, false);
            if (this.props.notifySelectedTests !== undefined) {
                this.props.notifySelectedTests([]);
            }
            this.setState({ selectedRowKeys: [] });     
        }
        let columnData = this.buildData(nextProps.tests);
        let columns = this.buildColumns();
        if (nextProps.tests.length > 0) {
            const pagination = { ...this.state.pagination };
            pagination.total = nextProps.tests.length;
            pagination.pageSize = 20 ;
            pagination.pageSizeOptions = ['20', '50', '75', '100'];
            pagination.showSizeChanger = true ;
            pagination.onShowSizeChange = this.onShowSizeChange;        
            pagination.showTotal = function (total: any) {
                return strings.formatString(strings.lsTotalTestTxt, total);
            };
            this.setState({
                loading: nextProps.loading,
                columnData: columnData,
                columns: columns,
                pagination,
                emptyText: nextProps.emptyText
            });
        } else {
            this.setState({
                loading: nextProps.loading,
                columnData: columnData,
                columns: columns,
                pagination: false,
                emptyText: nextProps.emptyText
            });
        }
    }

    onShowSizeChange(current: number, size: string) {
        console.log('onShowSizeChange', current);
        console.log('onShowSizeChange', size);
    }

    render() {
        const rowSelection = {
            selectedRowKeys : this.state.selectedRowKeys,
            onChange: this.onSelectChange,
            onSelectAll: selected => {
                let selectedRowKeys: any[] = [];
                if (selected) {
                 selectedRowKeys = this.state.columnData.map(row => row.testid);
                }
                this.setState({selectedRowKeys});
                this.props.notifySelectedTests(selectedRowKeys);
              }
        };

        return (
            <div>
            <Table
                className="TestListRow"                 
                rowSelection={this.props.notifySelectedTests === undefined ? undefined : rowSelection}
                columns={this.state.columns} 
                dataSource={this.state.columnData} 
                pagination={this.props.pagination ? this.state.pagination : this.props.pagination}
                rowKey={record => record.testid}
                loading={this.state.loading}
                locale={{ emptyText: this.state.emptyText }} 
            />
            {/* {this.state.testData.length > 0 &&
                this.state.testData.map((test, i) => {
                    return (<TestPdf
                        key={i}
                        index={i}
                        doc={doc}
                        isLast={i === this.state.testData.length - 1}
                        state={test}
                        setCanvas={(filename) => this.downloadTest(i)}
                        notifyDownload={() => this.notifyTestDownload()}
                    />);
                })
            } */}
            <Modal
                title={strings.lsEditTestTxt}
                visible={this.state.isModalVisisble}
                okText={strings.lsSaveTxt}
                onOk={() => this.setModalVisible(1)}
                onCancel={() => this.setModalVisible(0)}
                width={400}
                bodyStyle={{padding: 0 }}
                maskClosable={false}
                closable={false}
                
            >
                <Card className="filterCard" bordered={false} style={{ margin: '24px 16px' }}>
                    <Row className="row">
                    <Col xs={1} sm={1} md={1} lg={5} xl={2} />
                        <Col xs={14} sm={14} md={16} lg={10} xl={20}/>
                            
                        <Col xs={1} sm={1} md={2} lg={6} xl={2}/>
                    </Row>

                    <Row className="row">
                        <Col xs={1} sm={1} md={1} lg={5} xl={1} />
                        <Col xs={1} sm={1} md={1} lg={5} xl={10} >
                        {strings.lsBaselineTxt}
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={10}>
                        <div className="printOptions">
                        <RadioGroup 
                            className="labelFrame" 
                            value={this.state.baseline}
                            onChange={(val) => this.setState({baseline: val.target.value})}
                        >
                            <Radio defaultChecked={true}  value={1} >{strings.lsYesTxt}</Radio>
                            <Radio defaultChecked={false} value={0}>{strings.lsNoTxt}</Radio>
                        </RadioGroup>
                        </div>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={2}/>
                    </Row>  <br/>
                    {!this.state.baseline && 
                        this.props.testtags && 
                        this.props.testtags !== '' && <Row>
                        <Col xs={1} sm={1} md={1} lg={5} xl={1} />
                            <Col xs={1} sm={1} md={1} lg={5} xl={10} >
                                {strings.lsTestTagTxt}
                            </Col>
                            <Col xs={14} sm={14} md={16} lg={10} xl={10}>
                            <div className="printOptions">
                                {this.renderTesttags()}  
                            </div>
                            </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={2}/>  
                    </Row>}     
                    {/* <Row className="row">
                        <Col xs={1} sm={1} md={1} lg={5} xl={1} />
                        <Col xs={1} sm={1} md={1} lg={5} xl={10} >
                        {strings.lsConcussionTxt}
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={10}>
                        <div className="printOptions">
                        <RadioGroup 
                            className="labelFrame" 
                            value={this.state.concussed}
                            onChange={(val) => this.setState({concussed: val.target.value})}
                        >
                            <Radio defaultChecked={true}  value={1} >{strings.lsYesTxt}</Radio>
                            <Radio defaultChecked={false} value={0}>{strings.lsNoTxt}</Radio>
                        </RadioGroup>

                        </div>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={2}/>
                    </Row>  */}
                    </Card>    
            </Modal>
        </div>
        );
    }

    renderTesttags() {
        var testtags = this.props.testtags && this.props.testtags !== '' ? this.props.testtags.split(',') : [];
        return testtags.length > 0 ? 
            (
                <Select value={this.state.testtag} onChange={(e: any) => this.setState({testtag: e})}>
                    {   testtags.map((tag: string, index: number) => (
                                <Select.Option key={tag + index} value={tag}>{tag}</Select.Option>
                            )
                        )   
                    }
                </Select>
            ) : null;
    }

    private buildData(tests: Array<any>) {
        let columnData: Array<any> = [];
        tests.forEach( (element: any) => {
            let data: any = {
                testid: element.testid,
                playerid: element.playerid,
                player: element.athlete.firstname + ' ' + element.athlete.lastname,
                datetime: Utils.getDate(element.testtimestamp) + ' ' + Utils.getTime(element.testtimestamp),
                testtype: element.baseline === 1 ? BASELINETYPE.BASELINE : this.state.showHealthData ? 
                            Utils.getLocalizedTestType(element.range) 
                            : BASELINETYPE.TEST,
                testtag: element.testtag + (element.bestbaseline === true && element.baseline === 1 ? ' (best)' : ''),
                concussed: Utils.getConcussed(element.concussed),
                score: Utils.formatNumber(element.score, 2)
            };
            if (element.testinfo) {
                data.eye = element.testinfo.length ? 'Left' : 'Right';
            }
            columnData.push(data);
        }); 
        return columnData;
    }
    
    private buildColumns() {
        let columns = [
            this.props.showAthelete ? {
            title: strings.lsNameTxt,
            dataIndex: 'player',
            sorter: this.props.sorting ? (a: any, b: any) =>  a.player.localeCompare(b.player) : null,
            defaultSortOrder: this.props.sorting ? 'ascend' : null,
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
            
          } : {},
          {
            title: strings.lsDateTimeTxt,
            dataIndex: 'datetime',
            sorter: this.props.sorting ? (a: any, b: any) => Utils.dataDiff(a.datetime, b.datetime) : null,
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          {
            title: strings.lsTestTagTxt,
            dataIndex: 'testtag',
            sorter: this.props.sorting ? (a: any, b: any) =>  a.testtag.localeCompare(b.testtag) : null,
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          },
          this.state.showHealthData ? {
            title: strings.lsScoreTypeTxt,
            dataIndex: 'testtype',
            className: 'rows',
            sorter: this.props.sorting ? 
                            (a: any, b: any) => {
                                let atesttype = a.testtype !== null ? a.testtype : '';
                                let btesttype = b.testtype !== null ? b.testtype : '';
                                return atesttype <= btesttype ? -1 : 1;
            } : null,
            render: (text: any) => (
                                    <div style={{marginTop: 8}}>
                                        <div 
                                            className={text === 'Baseline' ? 'bluedot' 
                                                     : text === 'Extremely Poor'
                                                                || text === 'Very Poor'
                                                                || text === 'Poor'
                                                                ? 'reddot' : 'greendot'}
                                        />
                                        <div style={{ marginTop: -15, marginLeft: 10}}> {text} </div>
                                    </div>
                                    ),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
        } : {
                title: strings.lsScoreTypeTxt,
                dataIndex: 'testtype',
                className: 'rows',
                sorter: this.props.sorting ? 
                                (a: any, b: any) => {
                                    let atesttype = a.testtype !== null ? a.testtype : '';
                                    let btesttype = b.testtype !== null ? b.testtype : '';
                                    return atesttype <= btesttype ? -1 : 1;
            } : null,
            render: (text: any) => ( 
                <div style={{marginTop: 8}}>
                <div/>
                    <div style={{ marginTop: -15}}> 
                        {text === 'Baseline' ? BASELINETYPE.BASELINE : BASELINETYPE.TEST} 
                    </div>
                </div> 
            ),
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
        },
          
          this.state.showHealthData ? {
            title: strings.lsScoreTxt,
            dataIndex: 'score',
            sorter: this.props.sorting ? (a: any, b: any) => a.score - b.score : null,
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } : {},
          !this.props.showAthelete && !this.props.fromProfileList ? {
            title: strings.lsEyeTxt,
            dataIndex: 'eye',
            sorter: this.props.sorting ? (a: any, b: any) => a.eye.localeCompare(b.eye) : null,
            className: 'rows',
            onHeaderCell: (column) => {
                return {
                    onClick: () => {
                        this.setState({
                            columns: CustomSorter.cleanAndToggleSortOrder(this.state.columns, column.dataIndex)
                        });
                    }
                };
            }
          } : {},
        //   this.state.showHealthData ? {
        //     title: strings.lsConcussionTxt,
        //     dataIndex: 'concussed',
        //     className: 'rows',
        //     sorter: this.props.sorting ? 
        //                  (a: any, b: any) => a.concussed.toString().localeCompare(b.concussed.toString()) : null,
        //   } : {},
          this.state.showHealthData || this.props.showDownloadAction || this.props.showEditAction ?
          {
            title: strings.lsActionTxt,
            dataIndex: 'testid',            
            render: (text: any, record: any) => (
                   <div>
                       {this.state.showHealthData ? 
                        <Link 
                            // className="linkSpacing"
                            to={'/viewtest/' + record.testid}
                        >
                            {this.props.showDownloadAction ||  this.props.showEditAction ?
                                     strings.lsViewtxt + ' |' : strings.lsViewtxt }
                        </Link>
                       : ''}
                        {this.props.showDownloadAction ? 
                        <a                         
                            onClick={async (e) => {
                                let ser = new service();
                                let testResult = await this.getTestDetails(record.testid, 0);
                                let testHistory = await ser.getTestsAfterLastBaseline(
                                    testResult.playerid, testResult.testtimestamp
                                );
                                console.log('e in onlcick', record); 
                                let testData = {
                                    testResult,
                                    testHistory
                                };
                                e.stopPropagation();
                                TestPdf({
                                    index: 0,
                                    state: testData,
                                    doc: doc,
                                    isLast: true,
                                    singleTest: true,
                                    setCanvas: () => this.downloadTest(testResult, 0),
                                    notifyDownload: () => this.notifyTestDownload()
                                });
                                this.props.notifyTestDownload();
                        }}
                        > {this.props.showEditAction ? strings.lsDwnldTxt + ' |' : strings.lsDwnldTxt}
                        </a> : ''}
                        {this.props.showEditAction ? 
                        <a                         
                            onClick={ (e) => {    
                                console.log('e in onlcick', record);  
                                e.stopPropagation(); 
                                this.editTest(record);
                        }}
                        > {strings.lsEditTxt} 
                        </a> : ''}
                    </div>
            )
          } : {}
        ];
        return columns;
    }
    
    private notifyTestDownload() {
        canvas = [];
        doc = new jsPDF({
            orientation: 'landscape',
            unit: 'pt',
            format: 'letter',
        });
        this.props.notifyTestDownload();
    }

    // private setTestCanvas = async (test) => {
    //     console.log('downloadTest: ', test);
    //     let canvas: any = document.createElement('canvas');
    //     canvas.width = 1024;
    //     canvas.height = 768;
    //     let canvasView = new CanvasTestView(
    //         canvas[0], this.getCoords(baselineTestData),
    //         this.getCoords(record) ,
    //         record.baseline === 1, this.checkIfTestsIsImpaired(record.range), 
    //         Utils.getLocalizedTestType(record.range), 
    //         Utils.formatNumber(record.score, 2), 
    //         isOldData, isOldDataBaseline);
    //     await canvasView.setCanvasView();
    //     let img: any = document.querySelector('#canvas');
    //     img.src = canvas.toDataURL();
    //     img.width = 1024 * 0.5;
    //     img.height = 768 * 0.5;
    //     // console.log('canvas', canvas.toDataURL());
    // }

    private async downloadTest(testResult: any, index: number) {
        let profileInfo: any = [];
        console.log('test result', testResult);
        let baselineTestData: any;
        if (testResult.baseline === 1) {
            baselineTestData = testResult;
            console.log('in baseline');
        } else {
            baselineTestData = await this.getTestDetails(testResult.testid, 1);
        }
        let isOldData = testResult.calibaratedtestcoords === null ? true : false;
        let isOldDataBaseline = baselineTestData.calibaratedtestcoords === null ? true : false;
        canvas.push(document.createElement('canvas'));
        canvas[index].width = 1024;
        canvas[index].height = 768;
        profileInfo.push({
            profileName: testResult.athlete.firstname + ' ' + testResult.athlete.lastname,
            testtimestamp: testResult.testtimestamp,
            isBaseline: testResult.baseline === 1,
            orgName: testResult.athlete.organizationname
        });
        let canvasView: any;
        canvasView = new CanvasTestView(
            canvas[index], this.getCoords(baselineTestData),
            this.getCoords(testResult), testResult.baseline === 1,
            this.checkIfTestsIsImpaired(testResult.range), 
            Utils.getLocalizedTestType(testResult.range), 
            Utils.formatNumber(testResult.score, 2), 
            isOldData, isOldDataBaseline
        );
        await canvasView.setCanvasView();
        let img: any = new Image();
        img.src = canvas[index].toDataURL();
        img.width = 1024 * 0.5;
        img.height = 768 * 0.5;

        // if () {
        //     let ser = new service();
        //     await ser.testDownloaded(JSON.stringify(testResult.athlete));
        // }
        return img;
            // img.onload = () => {
            //     resolve();
            // };
        // });
        // let pdfCrtn = new PdfCreation('', '', false, '');
        // pdfCrtn.createPDF(canvas, profileInfo);
    }

    private editTest(e: any) {
        // show test modal
        console.log('target', e);
        this.setState({
            isModalVisisble: true,
            baseline: e.testtype.toString().trim().toLowerCase() === 'baseline' ? 1 : 0,
            concussed: e.concussed.toString().trim().toLowerCase() === 'no' ? 0 : 1,
            testToEdit: e,
            testtag: e.testtag,
        });
    }

    private async getTestDetails(testid: string, baseline: number) {
        let ser = new service();
        let data = await ser.getTestResults(testid, baseline);
        console.log('test results', data);
        return data[0];
    }

    private getCoords(data: any) {
        return  this.formatCorrds( 
            data.calibaratedtestcoords === null ? 
                data.testcoords : data.calibaratedtestcoords);
    }

    private checkIfTestsIsImpaired(range: string) {
        return range !== undefined ? 
        range.indexOf(strings.lsImpairedTxt) !== -1 : false;
    }
 
     private formatCorrds(coords: any) {
         console.log('formatCorrds', coords);
         if (coords !== undefined) {
             let data = coords;
             let formattedData: any = [];
             data.forEach((e: any) => {
                 formattedData.push({x: e.eye_x, y: e.eye_y});
             });
             console.log('formattedData', formattedData);
             return formattedData;
         }
     }
 
    /**
     * Closes the print confirmation modal and performs tasks as per the event
     * @param event Cancel/ Print click
     */
    private async setModalVisible(event: number) {
        if (event === 1) {// print click
            // this.printList();
            let ser = new service();
            let userInput = {
                'datetime' : this.state.testToEdit.datetime,
                'player' : this.state.testToEdit.player,
                'baseline' : this.state.baseline, 
                'concussed': this.state.concussed,
                'organization' : storage.getSelectedOrgName(),
                'testtag': this.props.testtags && this.props.testtags !== '' ? this.state.testtag : ''
            };
            let resp = await ser.editTest(this.state.testToEdit.testid, userInput);
            this.props.notifyTestUpdated(this.state.testToEdit.playerid);
            console.log('resp', resp);
        }         
        this.setState({isModalVisisble: false}, () => {
            console.log(this.state.isModalVisisble);
        });
    }
 
    //  private formatScore(score: number) {
    //      if (score !== undefined) {
    //          return score.toFixed(3);
    //      } else {
    //          return '0';
    //      }
 
    //  } 
}


// WEBPACK FOOTER //
// ./src/components/test/TestList.tsx